import styled from "styled-components";
import media from "styled-media-query";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  gap: 20px;

  width: 100%;
  font-family: ${({ theme }) => theme.font.fontFamily};

  color: ${({ theme }) => theme.colors.neutral.white};
`;

export const Row = styled.div`
  display: flex;
  gap: 20px;
  align-items: flex-end;

  width: 80%;

  ${media.lessThan("medium")`
    display: flex;
    flex-direction: column;

    width: 100%;
  `}
`;

export const Buttons = styled.div`
  padding-top: 40px;
  display: flex;
  justify-content: flex-end;
  gap: 20px;

  width: 100%;
`;
